export default __webpack_public_path__ + "static/media/Group 3179@2x.97b8ad1b.png";